import { useState, useEffect } from "react";
import { ITransferLogModel } from "../../models/transfers-model";
import { emptyLabels } from "../shared/constants";
import GridComponent from "../shared/grid";
import { ColDef, ValueGetterParams } from "ag-grid-community";
import { dateComparator, HeaderTemplate } from "../shared/grid/grid.services";
import PullToRefresh from "react-simple-pull-to-refresh";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';

interface IProps {
    onGridReady: (params: any) => void;
    logsData: ITransferLogModel[];
    refreshData: () => void;
    appliedFilters?: any;
    filterOptions: CustomFilterCategory[];
    IsFilterPresent: boolean;
    gridApi: any;
    selectedFilterTypes: string[];
}

const TransferLogs = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [Logs, setLogs] = useState<ITransferLogModel[]>([]);

    useEffect(() => {
        setLogs(props.logsData)
    }, [props.logsData])

    const TransferLogsColumnDefs: ColDef[] = [
        {
            field: "TransferredByName",
            headerName: "By",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TransferredByName
            },
            cellStyle: { textAlign: "left", lineHeight: "2rem", verticalAlign: "middle",marginTop: "0.75rem"},
        },
        {
            field: "SourcePhoneNumber",
            headerName: "From",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SourcePhoneNumber
            },
        },
        {
            field: "TargetPhoneNumber",
            headerName: "To",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TargetPhoneNumber
            },
        },
        {
            field: "CreditType",
            headerName: "Credit Type",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.CreditType
            },
            headerComponentParams: {
                template: !!props.selectedFilterTypes.includes("CreditType") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
        },
        {
            field: "CreditsTransferred",
            headerName: `${IsMobileDevice ? "Credits" : "Credit Amount"}`,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.CreditsTransferred
            },
        },
        {
            field: "TransferredAt",
            headerName: "Transferred On",
            hide: IsMobileDevice,
            sort: "desc",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TransferredAt
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.TransferredAt, nodeB.data.TransferredAt)
        },

    ]

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => props.refreshData())

    return (
        <>
            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                <div className="h-v-80">
                    <GridComponent
                        ColumnDefs={TransferLogsColumnDefs}
                        RowData={Logs}
                        OnGridReady={props.onGridReady}
                        IsPaginationEnabled={!IsMobileDevice}
                        EmptyLabel={emptyLabels.LOGS}
                        LockVisible={IsMobileDevice}
                        filterOptions={props.filterOptions}
                        IsFilterPresent={props.IsFilterPresent}
                        gridApi={props.gridApi}
                    />
                </div>
            </PullToRefresh>
        </>
    )
}
export default TransferLogs;